import { get, put } from "../../api/client";
import { StudentSchoolFees } from "../../Constants/Interfaces/payloadInterface/StudentPayload.interface";
import { useAppMutation, useAppQuery } from "../customReactQuery";

const STUDENT_SCHOOL_FEES_KEY = {
  STUDENT_SCHOOL_FEES: "STUDENT_SCHOOL_FEES",
};

export const useGetStudentdSchoolFees = ({
  studentId,
}: {
  studentId: number;
}) => {
  return useAppQuery(
    [STUDENT_SCHOOL_FEES_KEY.STUDENT_SCHOOL_FEES, studentId],
    () => {
      return get({
        url: `api/v1/student-school-fees/${studentId}`,
      });
    },
    {
      enabled: !!studentId,
    }
  );
};

export const useUpdateStudentSchoolFees = ({
  studentId,
  onSuccess,
  onError,
}: {
  studentId: number;
  onSuccess: (data: any) => unknown;
  onError: (error: unknown) => unknown;
}) =>
  useAppMutation(
    (body: StudentSchoolFees) =>
      put({
        url: `api/v1/student-school-fees/${studentId}`,
        body: body,
      }),
    {
      onSuccess,
      onError,
    }
  );
